import { UnitTransferSignerStatusEnumType } from '__generated__/graphql';

export default function unitTransferSignerStatusToReadable(
  status: UnitTransferSignerStatusEnumType
): {
  label: string;
  color: string;
} {
  switch (status) {
    case UnitTransferSignerStatusEnumType.Pending:
      return { label: 'Pending', color: 'gray' };
    case UnitTransferSignerStatusEnumType.Sent:
      return { label: 'Sent', color: 'sky' };
    case UnitTransferSignerStatusEnumType.Viewed:
      return { label: 'Viewed', color: 'amber' };
    case UnitTransferSignerStatusEnumType.Signed:
      return { label: 'Signed', color: 'green' };
    case UnitTransferSignerStatusEnumType.Declined:
      return { label: 'Declined', color: 'red' };
    default:
      return { label: status, color: 'gray' };
  }
}
